<button mat-icon-button class="msg-btn" style="display:none">
  <span>{{ number }}</span>
  <i class="material-icons icon-btn">{{ icon }}</i>
</button>
